import React, { useState } from "react"
import { Tabs, Tab } from 'components/shared/Tabs'
import MotusSummaryTab from "./MotusSummaryTab";

const MotusSummary = (props) => {

    const { tabsData } = props
    const [motusTabValue, setMotusTabValue] = useState(0)

    const labelFor = (name) => (
        name && /^\d+$/.test(String(name).trim()) ? `DOT ${String(name).trim()}` : name
    )
    const motusTabs = tabsData.map(item => ({ label: labelFor(item.tabName) }))
    const handleMotusTabsChange = (e, newValue) => { setMotusTabValue(newValue) }

    return (
        <div>
            {motusTabs.length > 1
                ? <Tabs
                    data={motusTabs}
                    value={motusTabValue}
                    onChange={handleMotusTabsChange}
                  />
                : <p className='singleTabMeta'>{motusTabs[0]?.label}</p>
            }
            {
                tabsData.map((records, index) => {
                    return (
                        <Tab value={motusTabValue} index={index} key={index}>
                            <MotusSummaryTab recordsByName={records}/>
                        </Tab>
                    )
                })
            }
        </div>
    )
}

export default MotusSummary